"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityQuoteComparisonReportDocumentMap = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const opportunity_quote_comparison_report_entity_1 = require("./opportunity-quote-comparison-report.entity");
const look_up_entity_1 = require("./look-up.entity");
let OpportunityQuoteComparisonReportDocumentMap = class OpportunityQuoteComparisonReportDocumentMap {
    constructor(quoteComparisonReportId, documentId, documentTypeLid) {
        this.quoteComparisonReportId = quoteComparisonReportId;
        this.documentId = documentId;
        this.documentTypeLid = documentTypeLid;
    }
};
exports.OpportunityQuoteComparisonReportDocumentMap = OpportunityQuoteComparisonReportDocumentMap;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], OpportunityQuoteComparisonReportDocumentMap.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "quote_comparison_report_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityQuoteComparisonReportDocumentMap.prototype, "quoteComparisonReportId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "document_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityQuoteComparisonReportDocumentMap.prototype, "documentId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "document_type_lid", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityQuoteComparisonReportDocumentMap.prototype, "documentTypeLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => opportunity_quote_comparison_report_entity_1.OpportunityQuoteComparisonReport, (report) => report.documents, { onDelete: "CASCADE" }),
    (0, typeorm_1.JoinColumn)({ name: "quote_comparison_report_id" }),
    tslib_1.__metadata("design:type", Object)
], OpportunityQuoteComparisonReportDocumentMap.prototype, "quoteComparisonReport", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => look_up_entity_1.LookUp, { onDelete: "SET NULL" }),
    (0, typeorm_1.JoinColumn)({ name: "document_type_lid" }),
    tslib_1.__metadata("design:type", Object)
], OpportunityQuoteComparisonReportDocumentMap.prototype, "documentType", void 0);
exports.OpportunityQuoteComparisonReportDocumentMap = OpportunityQuoteComparisonReportDocumentMap = tslib_1.__decorate([
    (0, typeorm_1.Entity)("opportunity_quote_comparison_report_document_map"),
    tslib_1.__metadata("design:paramtypes", [Number, Number, Number])
], OpportunityQuoteComparisonReportDocumentMap);
